(function () {
  'use strict';
  const selector = '[data-wp-before-after]';

  function initialize(root) {
    if (root.dataset.wpBeforeAfterReady) return;
    const range = root.querySelector('.wp-before-after__range');
    if (!range) return;
    root.dataset.wpBeforeAfterReady = 'true';
    let activePointer = null;

    function update(value) {
      const split = Math.round(Math.max(0, Math.min(100, value)));
      range.value = String(split);
      range.setAttribute('aria-valuetext', `${split}% before portrait, ${100 - split}% after illustration`);
      root.style.setProperty('--wp-before-after-split', `${split}%`);
    }

    function updateFromPointer(event) {
      const bounds = root.getBoundingClientRect();
      if (bounds.width) update(((event.clientX - bounds.left) / bounds.width) * 100);
    }

    range.addEventListener('input', function () { update(Number(range.value)); });
    root.addEventListener('pointerdown', function (event) {
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      activePointer = event.pointerId;
      range.focus({ preventScroll: true });
      root.setPointerCapture(event.pointerId);
      updateFromPointer(event);
    });
    root.addEventListener('pointermove', function (event) {
      if (activePointer === event.pointerId) updateFromPointer(event);
    });
    function finish(event) {
      if (activePointer !== event.pointerId) return;
      activePointer = null;
      if (root.hasPointerCapture(event.pointerId)) root.releasePointerCapture(event.pointerId);
    }
    root.addEventListener('pointerup', finish);
    root.addEventListener('pointercancel', finish);
    root.addEventListener('lostpointercapture', function () { activePointer = null; });
    update(Number(range.value));
  }

  function scan(scope) {
    if (scope.matches && scope.matches(selector)) initialize(scope);
    scope.querySelectorAll(selector).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }

  if (!window.wpBeforeAfterSectionListener) {
    window.wpBeforeAfterSectionListener = true;
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  }
})();
